<template>
  <v-app class="white" >
    <div class="text-xs-center">
      <v-icon v-if="status==null" style="font-size:80px;">
        fingerprint
      </v-icon>
      <v-icon v-else-if="status==true" style="font-size:80px;" class="green--text">
        check
      </v-icon>
      <v-icon v-else-if="status==false" style="font-size:80px;" class="red--text">
        close
      </v-icon>

      <br><br>

      <h2 v-if="status==null" class="title">Verify Certificate</h2>
      <h2 v-else-if="status==true" class="title">Valid Certificate Number </h2>
      <h2 v-else-if="status==false" class="title">No Certificate Number Found</h2>

      <p>Please type in your certification ID</p>

      <v-text-field
        label="Certificate ID"
        v-model="certID"
        color="#004282"
        @input="$v.certID.$touch()"
        @blur="$v.certID.$touch()"
        :error-messages="certIDErrors"
      ></v-text-field>
      <br>
      <v-btn round outline color="#004282"
        :disabled="$v.$invalid==true"
        :loading="isLoading==true"
        @click="verify()">Verify</v-btn>
      <br><br>


      <v-expansion-panel popout
        v-if="status==true"
      >
        <v-expansion-panel-content>
          <template v-slot:header>
            <div class="text-xs-center subheading">
              Certificate Details
            </div>
          </template>
          <v-card>
            <v-card-text>
              <table>
                <tr>
                  <td>
                    <b>Name:</b>
                  </td>
                  <td>
                    {{ details.name }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Course:</b>
                  </td>
                  <td>
                    {{ details.course }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Issue by:</b>
                  </td>
                  <td>
                    {{ details.issuer }}
                  </td>
                </tr>
                <tr>
                  <td class="pr-3">
                    <b>Award type:</b>
                  </td>
                  <td>
                    {{ details.award }}
                  </td>
                </tr>
              </table>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
  </v-app>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import axcelerate from './axcelerate.js';
import axios from 'axios';

const validCertID = (value) => {
  return value.match(/[^\w\-]/g) == null;
}


export default {
  name: 'app',
  mixins: [validationMixin],
  data () {
    return {
      //
      isLoading: false,
      status: null,
      certID: '',
      details: {
        name: null,
        course: null,
        issuer: null,
        award: null
      }
    }
  },
  validations: {
    certID: {
      required,
      validCertID
    },
  },
  // mounted() {
  //   this.certID = window.location.pathname.replace(/[^\d\-]/g, '');
  //   this.verify();
  // },
  computed: {
    certIDErrors () {
      const errors = []
      if (!this.$v.certID.$dirty) return errors
      !this.$v.certID.required && errors.push('Certificate ID is required')
      !this.$v.certID.validCertID && errors.push('Certificate ID only allow hyphen and alphanumeric characters')
      return errors
    },
  },
  methods: {
    verify() {
      if(!this.$v.$invalid) {
        this.isLoading = true;
        axios.get( axcelerate.verify(this.certID) )
        .then(response => {
          this.isLoading = false;

          var response = response.data;
          this.status = response.RESULT;
          if( this.status ) {
            this.details.name = response.DOCUMENT.DETAIL.GIVENNAME + " " + response.DOCUMENT.DETAIL.SURNAME;
            this.details.course = response.DOCUMENT.DETAIL.ACTIVITYNAME;
            this.details.award = response.DOCUMENT.DETAIL.AWARDTYPE;
            this.details.issuer = response.DOCUMENT.DETAIL.ISSUEDBY;
          }
        });
      }


    }
  },

}
</script>

<style>
.application--wrap {
  min-height: auto !important;
}

#verify-app {
  font-family: "Raleway", Raleway;
}

.v-input input {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0px !important;
}

.v-btn {
  border-radius: 5px !important;
  font-size: 16px !important;
  border-width: 2px !important;
  padding: 10px 35px !important;
  height: auto !important;
}

/* fallback */
@font-face {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: 400;
  src: local("Material Icons"), local("MaterialIcons-Regular"),
    url(https://fonts.gstatic.com/s/materialicons/v17/2fcrYFNaTjcS6g4U3t-Y5ZjZjT5FdEJ140U2DJYC3mY.woff2)
      format("woff2");
}

.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}
</style>
